<ng-container *ngIf="apiData$|async as softwareData">
    <h1 class="soft-head pb-3 mb-2">{{softwareData.softwareTitle}}</h1>
    <section class="d-flex justify-content-between software-general-block">
        <div class="soft-content">
            <div>{{'common.text_software_general_information_lable'|cxTranslate}}</div>
            <div>{{'common.text_software_language_lable'|cxTranslate}}:&nbsp;{{softwareData.softwareLanguage}}</div>
            <div>{{'common.text_software_size_lable'|cxTranslate}}:&nbsp;{{softwareData.softwareSize}}</div>
            <div>
                {{'common.text_software_operating_system_lable'|cxTranslate}}:&nbsp;{{softwareData.softwareOperatingSystem}}
            </div>
            <div>{{'common.text_software_software_producer_lable'|cxTranslate}}:&nbsp;{{softwareData.softwareProducer}}
            </div>
            <div>{{'common.text_software_licence_lable'|cxTranslate}}:&nbsp;{{softwareData.softwareLicence}}</div>
            <div>{{'common.text_software_software_version_lable'|cxTranslate}}:&nbsp;{{softwareData.softwareVersion}}
            </div>
            <div>{{'common.document_text_releaseDate'|cxTranslate}}{{softwareData.softwareReleaseDate|
                date:'dd-MM-yyyy'}}</div>
        </div>
        <ng-container *ngIf="!emailFlow">
            <div class="download-software-btn" *ngIf="softwareData.softwareRegistration ;  else download">
                <a class="btn btn-primary btn-block  software-download fs-20" [routerLink]="['/softwareRequest']"
                    [queryParams]="{code:softwareData.softwareCode}">
                    {{'common.text_software_search_button_download_lable'|cxTranslate}}
                    <img class="hover-img" src="icons/link-grey.svg" width="20px"></a>
            </div>
            <ng-template #download>
                <div>
                    <a class="btn btn-primary btn-block fs-20" target="_blank" [href]="softwareData?.softwareURL">
                        {{'common.text_software_search_button_download_lable'|cxTranslate}}
                        <img src="icons/link-white.svg" width="20px" alt="donwload software"></a>
                </div>
            </ng-template>
        </ng-container>
        <!-- For email flow download -->
        <ng-container *ngIf="emailFlow">
            <div>
                <a class="btn btn-primary btn-block fs-20" target="_blank" [href]="softwareData?.softwareURL">
                    {{'common.text_software_search_button_download_lable'|cxTranslate}}
                    <img src="icons/link-white.svg" width="20px" alt="donwload software"></a>
            </div>
        </ng-container>
    </section>
    <br><br>
    <div class="soft-head software-info-head">{{'common.text_software_information_lable'|cxTranslate}}</div>
    <section>
        <div class="soft-content" [innerHtml]="softwareData.softwareInformation"></div>
    </section>
    <div class="soft-head software-info-head">{{'common.text_software_feature_list_lable'|cxTranslate}}</div>
    <section>
        <div class="soft-content" [innerHtml]="softwareData.softwareFeatureList"></div>
    </section>
</ng-container>